import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
// import 'vanilla-cookieconsent/dist/cookieconsent.css';
import App from './App';
import './i18n';
import './styles/index.scss';
// import CookieConsent from "./components/CookieConsent";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    {/* <CookieConsent /> */}
  </React.StrictMode>
);
